// tslint:disable:max-classes-per-file

import classNames from "classnames";
import React from "react";
import { actions, Control } from "react-redux-form";
import _ from "underscore";

import { CheckBox, Errors } from "../../../../core/atoms/rrf";
import SvgIcon, { DEFAULT_ICON_SVG } from "../../../../core/atoms/svgIcon";
import { CommonProps, EnquiryFormSection } from "./common";
import { FormProgressIcon } from "./formProgressIcon";

import "./themesSelect.scss";

interface ThemesSelectProps {
  enquiryThemes: ITheme[];
  dispatch: any;
}

class ThemeCheckBox extends React.Component<{ theme: ITheme; }> {
  public render() {
    const { theme, ...inputProps } = this.props;

    return (
      <label className="rrf-theme-check-box">
        <input value={theme.id} {...inputProps} />
        <SvgIcon svg={theme.icon || DEFAULT_ICON_SVG} />
        <p>{theme.name}</p>
      </label>
    );
  }
}

export class ThemesSelect extends EnquiryFormSection<ThemesSelectProps> {
  protected shouldUpdateValidity(oldProps: CommonProps, newProps: CommonProps) {
    return !_.isEqual(oldProps.formState.themes, newProps.formState.themes);
  }

  protected syncValidity(formState: Forms.EnquiryForm) {
    if (!formState.themes) {
      return;
    }

    const isChoosingThemes = formState.themes.noThemes !== true; // field defaults to null
    const isValid = !isChoosingThemes || Array.isArray(formState.themes.themeIds) && formState.themes.themeIds.length > 0;
    this.props.dispatch(actions.setValidity(this.props.model, { themesRequired: isValid }));
  }

  private resetThemes = () => this.props.dispatch(actions.reset(`${this.props.model}.themeIds`));

  /**
   * BR: 'Highlights' theme should be presented first
   */
  private getSortedEnquiryThemes() {
    const sorted = _.sortBy(this.props.enquiryThemes, x => x.name);

    const highlightsIndex = _.findIndex(sorted, x => x.name === "Highlights");
    if (highlightsIndex >= 0) {
      sorted.unshift(sorted.splice(highlightsIndex, 1)[0]);
    }

    return sorted;
  }

  public render() {
    const { model, className, id, formState } = this.props;
    const isNotSureSelected = formState && formState.themes != null ? formState.themes.noThemes : false;
    const enquiryThemes = this.getSortedEnquiryThemes();

    if (enquiryThemes.length < 1) {
      return null;
    }

    return (
      <section id={id} className={classNames("themes-select", className)}>
        <header>
          <FormProgressIcon model={model} />
          <h2>What kind of holiday would you like?</h2>
          <p>Choose a few travel themes from the selection below. This will help our local experts better plan just the kind of trip you're looking for.</p>
        </header>
        <div className="enquiry-form-question">
          <Errors model={model} messages={{ themesRequired: `Please choose some themes for your holiday, or choose "Advise me"` }} />

          <div className="themes-wrap">
            {enquiryThemes.map(theme =>
              <Control.checkbox
                key={theme.id}
                model={`${model}.themeIds[]`}
                component={ThemeCheckBox}
                controlProps={{ theme }}
                value={theme.id}
                disabled={isNotSureSelected}
              />,
            )}
          </div>

          <CheckBox
            id="include-themes"
            model={`${model}.noThemes`}
            label="Advise me"
            subLabel="Your local expert will do their best to build an itinerary you love"
            onCheckedChange={isChecked => isChecked && this.resetThemes()}
          />
        </div>
      </section>
    );
  }
}
